import React, {FC} from "react";
import {IIcon} from "../interfaces/IIcon";
import Icon from "@ant-design/icons";

const SVG: FC = () => (
  <svg width="1em" height="1em" version="1.1" viewBox="0 0 262.39 147.84" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m191.58 110.45c-6.025 0-10.926-4.905-10.926-10.93 0-6.025 4.901-10.926 10.926-10.926 6.026 0 10.927 4.9 10.927 10.926 0 6.026-4.901 10.93-10.927 10.93m-120.77 0c-6.025 0-10.926-4.905-10.926-10.93 0-6.025 4.9-10.926 10.926-10.926 6.025 0 10.926 4.9 10.926 10.926 0 6.026-4.9 10.93-10.926 10.93m124.69-65.82 21.838-37.822a4.548 4.548 0 0 0-1.663-6.206 4.549 4.549 0 0 0-6.206 1.663l-22.111 38.3c-16.91-7.716-35.9-12.015-56.164-12.015s-39.254 4.299-56.163 12.015l-22.112-38.3a4.549 4.549 0 0 0-6.206-1.663 4.545 4.545 0 0 0-1.663 6.206l21.838 37.822c-37.499 20.395-63.146 58.358-66.898 103.21h262.41c-3.755-44.85-29.402-82.814-66.898-103.21"
      // fill="#3ddb85"
      fill="currentColor"
    />
    <path d="m-102.33-102.32h467.05v250.16h-467.05z" fill="none"/>
  </svg>
);
const IconAndroid: FC<IIcon> = props => <Icon component={SVG} {...props} />;
export default IconAndroid;